import Utility from "../../../../utility/utility";
import LanguageManager from "../../../../manager/language_manager";
import GameUtil from "../../../../utility/game_util";
import ModelData, { IUserData } from "../../../public/model_data";
import UserDataManager from "../../../../manager/user_manager";
import ModuleManager from "../../../../framework/core/module_manager";
import PlayerIconModule from "../playericon/playerIcon";
import ComponentBase from "../../../public/component/component_base";
import TablePlayerAvatar from "../../../table/components/table_player_avatar";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RankItem extends ComponentBase {

    @property(cc.Label)
    indexLab:cc.Label = null

    @property(cc.Sprite)
    indexSpr:cc.Sprite = null

    @property(cc.Label)
    goldLab:cc.Label = null

    @property(cc.Prefab)
    avatarPrefab: cc.Prefab = null

    @property(cc.Node)
    nodeAvatarParent: cc.Node = null

    @property(cc.Label)
    playerName:cc.Label = null

    @property(cc.SpriteFrame)
    rankIndexSpr:cc.SpriteFrame[] = []

    @property(cc.Node)
    infoNode:cc.Node = null

    @property(cc.Sprite)
    bgSpr:cc.Sprite = null

    @property(cc.SpriteFrame)
    bgSprFrame:cc.SpriteFrame[] = []

    itemData = null

    protected m_avatar: TablePlayerAvatar = null

    setData( data: any, index: number, isBottom = false){
        let self = this
        // if (data.rank == null){
        //     this.itemData = null
        //     this.infoNode.active = false
        //     if (!isBottom){
        //         this.bgSpr.spriteFrame = this.bgSprFrame[0]
        //     }
        //     return
        // }
        this.itemData = data
        if (isBottom){
            this.bgSpr.spriteFrame = this.bgSprFrame[0]
        }
        else{
           if (data.gameUserId == ModelData.instance.roleData.id){
            this.bgSpr.spriteFrame = this.bgSprFrame[1]
           }
           else{
            this.bgSpr.spriteFrame = this.bgSprFrame[2]
           }
        }
        this.goldLab.string = GameUtil.currencyFormat(data.val)
        if (data.rank > 0 && data.rank <= 3){
            this.indexLab.string = ""
            this.indexSpr.spriteFrame = this.rankIndexSpr[data.rank - 1]
            this.indexSpr.node.active = true
        }
        else if (data.rank > 3){
            this.indexLab.string = data.rank
            this.indexSpr.node.active = false
        }
        else{
            this.indexLab.string = ""
            this.indexSpr.node.active = false
        }

        //VIP标记显示
        let vipList = data.vipConfigList != null ? data.vipConfigList : []
        for (const vipData of vipList) {
            if (vipData.code == "SYS_Vip_Scard"){
                
            }
            else if (vipData.code == "SYS_Vip_Gcard"){
                
            }
            else if (vipData.code == "SYS_Vip_Gcard"){
              
            }
        }
        this.playerName.string = data.nickName

        this.infoNode.active = true
        // UserDataManager.getAvatarSprite(data.headImg,(spriteFrame)=>{
        //     this.headIcon.spriteFrame = spriteFrame
        // });

        this.m_avatar = this.m_avatar || this.getAvatar()
        this.m_avatar.isRankAvatar = true
        this.m_avatar.show(true, data.gameUserId)

    }

    getAvatar(): TablePlayerAvatar{
        let node = cc.instantiate(this.avatarPrefab)
        node.parent = this.nodeAvatarParent
        node.scale = 1
        node.position = cc.Vec3.ZERO
        return node.getComponent(TablePlayerAvatar)
    }

}
